import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=3c84e018&"
import script from "./AccountSettings.vue?vue&type=script&lang=js&"
export * from "./AccountSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c84e018')) {
      api.createRecord('3c84e018', component.options)
    } else {
      api.reload('3c84e018', component.options)
    }
    module.hot.accept("./AccountSettings.vue?vue&type=template&id=3c84e018&", function () {
      api.rerender('3c84e018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Pages/AccountSettings.vue"
export default component.exports